"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePrismicSaleBanner", {
  enumerable: true,
  get: function get() {
    return _usePrismicSaleBanner["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
var _usePrismicSaleBanner = _interopRequireDefault(require("./usePrismicSaleBanner"));
var _fetcher = _interopRequireDefault(require("./fetcher"));